import { generatePath } from 'react-router-dom'
import { GridCellProps, GridColumnProps } from '@progress/kendo-react-grid'
import {
  TradingAccountClientDto,
  TradingAccountClientDtoKey,
} from 'api/Trading-Accounts/Types/TradingAccountClientDto'
import { Link } from 'components/Link'
import { formatLocalDateUTC } from 'utils/date'
import { links } from 'utils/featureToggles'

import './IntroducingBroker.scss'

export interface GridColumn extends GridColumnProps {
  show: boolean
  width?: number
}

const introducingBrokerClientDetailsColumn: GridColumn[] = [
  {
    title: 'Name',
    field: TradingAccountClientDtoKey.name,
    cell: (props: GridCellProps) => (
      <td
        className='introducing-broker-table-columns__content'
        style={{ color: 'var(--link)', textDecoration: 'underline' }}
      >
        <Link
          state={{ redirectTo: links.recordsIntroducingBrokers.url }}
          to={{
            pathname: generatePath(links.recordsClients.detailsUrl as string, {
              id: props.dataItem.id,
              slug: 'details',
            }),
          }}
        >
          {props.dataItem.name}
        </Link>
      </td>
    ),
    show: true,
    className: 'introducing-broker-table-columns__content',
    filterable: true,
    filter: 'text',
  },
  {
    title: 'Country',
    field: TradingAccountClientDtoKey.countryId,
    show: true,
    className: 'introducing-broker-table-columns__content',
    filterable: true,
    filter: 'text',
  },
  {
    title: 'IB Profile',
    cell: (props: GridCellProps) => {
      const item: TradingAccountClientDto = props.dataItem

      if (!item?.introducingBroker) {
        return <td />
      }

      const { id, name } = item.introducingBroker

      return (
        <td
          className='introducing-broker-table-columns__content'
          style={{ color: 'var(--link)', textDecoration: 'underline' }}
        >
          <Link
            state={{ redirectTo: links.recordsIntroducingBrokers.url }}
            to={{
              pathname: generatePath(links.recordsIntroducingBrokers.detailsUrl as string, {
                id,
                slug: 'details',
              }),
            }}
          >
            {name}
          </Link>
        </td>
      )
    },
    show: true,
    className: 'introducing-broker-table-columns__content',
    filterable: true,
    filter: 'text',
  },
  {
    title: 'Assigned At',
    field: TradingAccountClientDtoKey.introducingBrokerAssignedAt,
    cell: (props: GridCellProps) => (
      <td className='table-columns__date'>
        {formatLocalDateUTC(props.dataItem.introducingBrokerAssignedAt, true)}
      </td>
    ),
    filterable: true,
    show: true,
    filter: 'text',
  },
]

export default introducingBrokerClientDetailsColumn
